module.exports = __webpack_public_path__ + "static/img/4.42e0405.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/4.png
// module id = QVTc
// module chunks = 0